import {
  TextField,
  Button,
  Grid,
  Paper,
  IconButton,
  CircularProgress,
  alpha
} from '@mui/material';
import {
  Search as SearchIcon,
  Clear as ClearIcon
} from '@mui/icons-material';
import { useTheme } from '@mui/material/styles';

const WordSearchInput = ({
  searchWord,
  onChange,
  onClear,
  onSearch,
  onKeyPress,
  loading,
  canLookup,
  placeholder = "e.g. read, lead, bow"
}) => {
  const theme = useTheme();

  return (
    <Paper 
      variant="outlined" 
      sx={{ 
        p: 2, 
        mb: 3, 
        bgcolor: alpha(theme.palette.background.paper, 0.6),
        borderColor: alpha(theme.palette.common.white, 0.1)
      }}
    >
      <Grid container spacing={2} alignItems="center">
        <Grid item xs={12} sm={6} md={4}>
          <TextField
            fullWidth
            label="Enter a word"
            value={searchWord}
            onChange={onChange}
            variant="outlined"
            placeholder={placeholder}
            size="small"
            onKeyPress={onKeyPress}
            InputProps={{
              endAdornment: searchWord ? (
                <IconButton 
                  size="small" 
                  onClick={onClear}
                  sx={{ color: theme.palette.text.secondary }}
                >
                  <ClearIcon fontSize="small" />
                </IconButton>
              ) : null
            }}
          />
        </Grid>
        <Grid item xs={12} sm={6} md={4}>
          <Button
            variant="contained"
            color="primary"
            onClick={onSearch}
            disabled={!canLookup}
            startIcon={loading ? <CircularProgress size={20} color="inherit" /> : <SearchIcon />}
          >
            {loading ? 'Searching...' : 'Look Up Word'}
          </Button>
        </Grid>
      </Grid>
    </Paper>
  );
};

export default WordSearchInput;